import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis'
import axios from 'axios';

import LocalStorage from "../../utils/storage";

const ROLE = LocalStorage.getItem('userRole');

export const createSkuFabricMaterial = createAsyncThunk('createSkuFabricMaterial', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/create-sku-material/UI/product_fabric`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getFabricMaterial = createAsyncThunk('getFabricMaterial', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/get-materials/product_fabric`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const generateFabricLabels = createAsyncThunk('generateFabricLabels', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/generate-fabric-labels`
  try {
      const response = await axios.post(URL, data)
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'fabric_label.pdf');
      document.body.appendChild(link);
      link.click();
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const updateSkuFabricMaterial = createAsyncThunk('updateSkuFabricMaterial', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/update-sku-material/product_fabric`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getFabricMaterialConfig = createAsyncThunk('getFabricMaterialConfig', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/get-material-properties-config/product_fabric`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getFabricVendors = createAsyncThunk('getFabricVendors', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/get-vendors`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const deleteSkuMaterial = createAsyncThunk('deleteSkuMaterial', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/delete-sku-material`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
})